import styled from 'helpers/styles';
import PropTypes from 'prop-types';
import ComponentStyles from 'styles/mixins/Component.styles';
import HeaderBar from 'components/organisms/Bars/HeaderBar/HeaderBar';

const StyledProfileBar = styled(HeaderBar)`
  .ProfileBar {
    &-navigation {
      min-height: unset;
      align-items: flex-start;
      padding-bottom: ${props => props.theme.spacing(0.75)};    
    }
  }
  
  &:not(.ProfileBar-inset) {
    height: unset;
    .PageBar-toolbar:first-child {
      height: ${props => props.theme.layout(64)};
    }
    
    &:has(.ContentNavigation) {
      .PageBar-toolbar {
        margin-bottom: ${props => props.theme.layout('-0.75sp')};
      }
    }
  }
  
  ${ComponentStyles}
`;

StyledProfileBar.propTypes = {
  theme: PropTypes.object
};

export default StyledProfileBar;
